// extracted by mini-css-extract-plugin
export default {"image_container":"PassportStudentPhoto_image_container__kqeMu","container":"PassportStudentPhoto_container__OwbN-","heading":"PassportStudentPhoto_heading__TttPp"};